export default {
  baseURL: "https://jplty.universerlove.jp",
};
